import { ENV, TFI } from "../../client-config";

const dev = {
  primary: "#5f00a0",
  primary40: "rgba(0,151,167, 0.4)",
  lightGreenBg: "#f2f9fa",
  cardTitleBg: "#e5f4f6",
};

const tfi = {
  primary: "#002c56",
  primary40: "rgba(0,44,86,0.4)",
  lightGreenBg: "rgba(239,60,65,0.07)",
  cardTitleBg: "#E5E9EE",
};

const common = {
  yellowTab: "#d1c500",
  graphPink: "rgb(249, 37, 103)",
  graphPink20: "rgba(249, 37, 103, 0.2)",
  graphPink40: "rgba(249, 37, 103, 0.4)",
  graphPink80: "rgba(249, 37, 103, 0.8)",
  graphPinkBg: "#ffd3e1",
  graphPurple: "rgb(173, 48, 171)",
  graphPurple20: "rgba(173, 48, 171, 0.2)",
  graphPurple40: "rgba(173, 48, 171, 0.4)",
  graphPurple80: "rgba(173, 48, 171, 0.8)",
  graphBlue: "rgb(0, 155, 255)",
  graphBlue20: "rgba(0, 155, 255, 0.2)",
  graphBlue40: "rgba(0, 155, 255, 0.4)",
  graphBlue80: "rgba(0, 155, 255, 0.8)",
  graphBlueBg: "#ccebfe",
  graphGreen: "rgb(6, 159, 0)",
  graphGreen20: "rgba(6, 159, 0, 0.2)",
  graphGreen40: "rgba(6, 159, 0, 0.4)",
  graphGreen80: "rgba(6, 159, 0, 0.8)",
  graphGreenBg: "#ccecd3",
  graphYellow: "rgb(249, 168, 37)",
  graphYellow20: "rgba(249, 168, 37, 0.2)",
  graphYellow40: "rgba(249, 168, 37, 0.4)",
  graphYellow80: "rgba(249, 168, 37, 0.8)",
  graphYellowBg: "#ffedd8",
  lightBlue: "#dbecff",
  lightOrange: "#fff2dd",
  veryLighPink: "#dddddd",
  pinkishGrey: "#bbbbbb",
  grey: "#dadcdc",
  white: "#fff",
  black: "#000",
  black7: "rgba(0,0,0,0.07)",
  black8: "rgba(0,0,0,0.08)",
  black10: "rgba(0,0,0,0.10)",
  black12: "rgba(0,0,0,0.12)",
  black23: "rgba(0,0,0,0.23)",
  black20: "rgba(0,0,0,0.20)",
  black24: "rgba(0,0,0,0.24)",
  black38: "rgba(0,0,0,0.38)",
  black54: "rgba(0,0,0,0.54)",
  black87: "rgba(0,0,0,0.87)",
  black542: "#b5b5b5",
  tableDarkBg: "rgba(251,251,251,1)",
  darkGrey: "#979797",
  darkGrey2: "#9e9e9e",
  lightGrey: "#f8f8f8",
  mediumGrey: "#d8d8d8",
  borderGrey: "#eaeaea",
  errorRed: "#eb3c39",
  green10: "#fafced",
  cardDarkBg: "#f0f3f3",
  redFlag: "#EB3C39",
  orange20: "rgba(246,161,76,0.2)",
  orange10: "rgba(246,161,76,0.1)",
  warningOrange: "#eca458",
  warningOrange10: "#fef5ed",
  selectedOrange: "#f6a14c",
  green: "#2fb326",
  primary10: "rgba(0,151,167,0.1)",
  roiBlue: "#00E7FF",
  unknownYellow: "#ffeb3b",
  threatRed: "#ef3c41",
  threatRed10: "#fdebeb",
  lightRed: "#fdf1f1",
  cardGreen: "#68AC58",
  cardGreen10: "#f0f7ee",
  cardGreen20: "rgba(104,172,88,0.2)",
  yellowBg: "#faf9e5",
  pinkBg: "#f6eaf6",
  isoYellow: "#d1c500",
  bodyPink: "#ad30ab",
  activeYellow: "#f9d6b3",
  dashboardOrange: "#f8cbad",
  questionBg: "#fbfbfb",
  greyBadgeBg: "#ebebeb",
  blueROI: "#00E7FF",
  greenDoughnut: "#8bc34a",
  yellowDoughnut: "#EAD80D",
  greyDoughnut: "#f6f6f6",
  redCoral: "#ef5350",
  darkBlue: "#202b2d",
  mediumBlue: "#4cb6c1",
  veryLightBlue: "#cceaed",
  dashboardDarkBlue: "#0277bd",
  dashboardLightBlue: "#b3d6eb",
  orangeAssistance: "#FF9800",
  manualTempBlue: "#4a9eff",
  calendarLightBlue: "#e5f4f6",
  calendarOrange: "#ffd695",
};

const colors = {
  ...common,
  ...(ENV === TFI ? tfi : dev),
};

export default colors;
